import { useLocation } from "react-router-dom";
import BssoPermissions from 'components/LM/Bsso/Permissions';
import VoiceValidationSearch from "components/LM/Voice/ValidationSearch/VoiceValidationSearch";

function VoicesValidationSearch() {
	const urlSearchParams = new URLSearchParams(useLocation().search);
	const searchParams = getSearchParams(urlSearchParams);

	return (
		<BssoPermissions permissions={["voices"]} behaviour="error">
			<VoiceValidationSearch searchParams={searchParams} />
		</BssoPermissions>
	);
}

function getSearchParams(urlSearchParams) {
	const term = urlSearchParams.get('term') || '';
	const type = urlSearchParams.get('type') || '';
	const channel = urlSearchParams.get('channel') || '';
	const country = urlSearchParams.get('country') || '';
	const labels = urlSearchParams.get('labels') || '';
	const status = urlSearchParams.get('status') || '';
	const validated = urlSearchParams.get('validated') || '';
	const upload_csv_file_id = urlSearchParams.get('upload_csv_file_id') || '';
	const last_edited_by = urlSearchParams.get('last_edited_by') || '';
	const country_confidence_min = urlSearchParams.get('country_confidence_min') || '';
	const country_confidence_max = urlSearchParams.get('country_confidence_max') || '';
	const type_confidence_min = urlSearchParams.get('type_confidence_min') || '';
	const type_confidence_max = urlSearchParams.get('type_confidence_max') || '';
	const missing_mandatory_fields = urlSearchParams.get('missing_mandatory_fields') || '';
	const to_merge_only = urlSearchParams.get('to_merge_only') || '';
	const has_recent_publications = urlSearchParams.get('has_recent_publications') || '';
	const has_recent_brand_mentions = urlSearchParams.get('has_recent_brand_mentions') || '';
	const voice_name_duplicates = urlSearchParams.get('voice_name_duplicates') || '';
	const follower_channels = urlSearchParams.get('follower_channels') || '';
	const followers_min = urlSearchParams.get('followers_min') || '';
	const followers_max = urlSearchParams.get('followers_max') || '';
	const last_edited_date_start = urlSearchParams.get('last_edited_date_start') || '';
	const last_edited_date_end = urlSearchParams.get('last_edited_date_end') || '';
	const list_id = urlSearchParams.get('list_id') || '';
	const voice_ids = urlSearchParams.get('voice_ids') || '';
	const combine_with_filters = urlSearchParams.get('combine_with_filters') || '';

	return { term, type, channel, country, labels, status, validated, upload_csv_file_id, last_edited_by, country_confidence_min, country_confidence_max, type_confidence_min, type_confidence_max, missing_mandatory_fields, to_merge_only, has_recent_publications, has_recent_brand_mentions, voice_name_duplicates, follower_channels, followers_min, followers_max, last_edited_date_start, last_edited_date_end, list_id, voice_ids, combine_with_filters };
}

export default VoicesValidationSearch;
